// extracted by mini-css-extract-plugin
export default {"day__header":"Day_day__header__RA-+N","day__title":"Day_day__title__H5x35","day__location":"Day_day__location__rfKwS"};